import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseAccessPolicy from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAccessPolicy';
import {ObjectTypes} from '../../../../api/consts';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {accessPolicyIcon} from "../../../../assets/images/headerIcons";
// /**
//  * @typedef {Object} Rule
//  * @property {number} xyz 
//  */

// /**
//  * @typedef {Object} Gateway
//  * @property {number} id 
//  * @property {Rule[]} rules 
//  */

const pageSchema = GatewayGetSchema.pages.accessPolicy;
const pageId = pageSchema.pageId;

function GatewayAccessPolicy({
                                 gatewayObject,
                                 planObject,
                                 setGatewayData,
                                 appiData,
                                 uoTableData,
                                 zonesData,
                                 setUoTableDataValue,
                                 setAppiDataValue
                             }) {
    const {t} = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];
    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const gatewayName = gatewayObject[GatewayGetSchema.id];

    const setPageValue = useCallback((param, newValue) => {
        setGatewayData([pageId, param], newValue);
    }, [setGatewayData]);


    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setPageValue(pageSchema.manageInSmp, planPage[pageSchema.manageInSmp]);
            setPageValue(pageSchema.mode, planPage[pageSchema.mode]);
            setPageValue(pageSchema.ruleBaseType, planPage[pageSchema.ruleBaseType]);
            setPageValue(pageSchema.legacyRules, planPage[pageSchema.legacyRules]);
            setPageValue(pageSchema.nextGenRules, planPage[pageSchema.nextGenRules]);
        }
        setPageValue(pageSchema.lockedToPlan, locked);
    }, [setPageValue, planPage]);

    return (
        <>
            <LockToPlanContainer
                accessPolicy
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMP.GATEWAYS.INNER_MENU.ACCESS_POLICY')}
                icon={accessPolicyIcon}
            >
                <BaseAccessPolicy
                    pageData={currentPageData}
                    setObjectData={setGatewayData}
                    pageDisabled={lockedToPlan}
                    baseObjectName={gatewayName}
                    objectType={ObjectTypes.GATEWAY}
                    appiData={appiData}
                    uoTableData={uoTableData}
                    zonesData={zonesData}
                    setUoTableDataValue={setUoTableDataValue}
                    setAppiDataValue={setAppiDataValue}
                />
            </LockToPlanContainer>
            <Indentation>
                <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.FWAllRulebase')}><SMCIcon
                    style={{verticalAlign: 'middle'}}
                    icon="seamlessLogin"/> {t('SMP.ACCESS_GATEWAY.FIREWALL_ACCESS_POLICY')}</SMCLink>
            </Indentation>
        </>
    );
}

export default GatewayAccessPolicy;